import React from 'react';
import { ReactComponent as LoadingCircle } from 'assets/images/loading.svg';
import styles from './Loading.module.scss';

export const SmallLoading = ({ size = 20 }) => {
    return (
        <div className={styles.loading} style={{ height: size + 'px' }}>
            <LoadingCircle className={styles.circle} stroke="var(--sm-brand-primary)" width={size} height={size} />
        </div>
    );
};
